export default {
  namespaced: true,
  state: {
    status: '', // enum COMPLETE, LOADING, OR ERROR
    detail: '',
    subdetail: '',
  },
  actions: {
    CHANGE: ({ commit }, loaderParams) => {
      commit('change', loaderParams)
    },
  },
  getters: {
    show: state => state.status === 'LOADING' || state.status === 'ERROR',
  },
  mutations: {
    change: function(state, loaderParams) {
      state.status = loaderParams.status || ''
      state.detail = loaderParams.detail || ''
      state.subdetail = loaderParams.subdetail || ''
    },
  },
}
